module.exports = __webpack_public_path__ + "static/media/excessive-drive-light.9f016a0a.svg";